export default __webpack_public_path__ + "static/media/LogoWithoutText.b8be6762.svg";